import {useCallback, useEffect, useState} from 'react';

export const ButtonState = {
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error',
};

const useFacebookInitialization = () => {
  const [buttonState, setButtonState] = useState(ButtonState.PENDING);

  const showButton = useCallback(() => setButtonState(ButtonState.SUCCESS), [setButtonState]);
  const showError = useCallback(() => setButtonState(ButtonState.ERROR), [setButtonState]);

  useEffect(() => {
    if (window.fbInitialized) {
      showButton();
      return;
    }
    if (window.fbInitFailed) {
      showError();
      return;
    }

    const timeout = setTimeout(() => {
      showError();
      removeListeners();
    }, 5000);

    const removeTimeout = () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };

    const removeListeners = () => {
      removeTimeout();
      window.removeEventListener('fbInitialized', handleInit);
      window.removeEventListener('fbInitFailed', handleFailedInit);
    };

    const handleInit = () => {
      showButton();
      removeListeners();
    };

    const handleFailedInit = () => {
      showError();
      removeListeners();
    };

    window.addEventListener('fbInitialized', handleInit);
    window.addEventListener('fbInitFailed', handleFailedInit);
    return () => {
      removeListeners();
    };
  }, [showButton, showError]);

  return buttonState;
};

export default useFacebookInitialization;
